const ChatTypingLoader = () => {
  return (
    <div
      className="d-flex align-items-start mb-3"
      role="status"
      aria-live="polite"
      aria-label="Assistant is typing"
    >
      <div className="p-3 rounded bg-light-primary d-flex align-items-center">
        <span className="me-2">Assistant is typing</span>
        <div className="typing-dots" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
      </div>
    </div>
  );
};

export default ChatTypingLoader;